export default "__VITE_ASSET__FNToLUyM__"